import React from 'react';
import { PagePath, RowHeaderTable, TableDrivers } from '../../components';
import PrivateDriversTable from '../../components/molecules/configuration/privateDrivers/privateDriversTable';

const PrivateDrivers: React.FC = () => {
  return (
    <div className="container-body no-padding">
      <RowHeaderTable name="Motoristas da casa" />
      <PrivateDriversTable />
    </div>
  );
};

export default PrivateDrivers;
